import ApplicationConfig from '@/lib/application-config'
import store from '@/store'
import connectHttpBase from '@/lib/connect-client/connect-http-base'
import storage from '@/lib/storage'

class ConnectAuthClient {
  constructor() {
    this.refreshTokenDaemonIntervalId = null
  }

  endpoint(path) {
    return ApplicationConfig.getAuthServer() + path
  }

  startRefreshTokenDaemon() {
    if (this.refreshTokenDaemonIntervalId === null) {
      this.refreshTokenDaemonIntervalId = setInterval(
        function() {
          const promise = this.refreshAccessToken()
          if (promise) {
            promise
              .then(response => {
                store.dispatch('authRefreshTokenSuccess', response.data)
              })
              .catch(error => {
                console.error(error)
              })
          }
        }.bind(this),
        ApplicationConfig.refreshTokenIntervalSeconds
      )
    }
  }

  login(credentials) {
    const endpoint = this.endpoint('/token')
    const email = credentials.email
    const password = credentials.password

    // ここのエンドポイントはFormでPOST
    let formData = new URLSearchParams()
    formData.append('appId', ApplicationConfig.getClientId())
    formData.append('grant_type', 'password')
    formData.append('email', email)
    formData.append('password', password)
    return connectHttpBase.getHttpClient().post(endpoint, formData)
  }

  changePassword(currentPassword, newPassword) {
    const endpoint = this.endpoint('/v1/user/password')
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, { currentPassword, newPassword })
  }

  createPassword(newPassword) {
    const endpoint = this.endpoint('/v1/oauth/password')
    return connectHttpBase.getAuthenticatedHttpClient().post(endpoint, { newPassword })
  }

  resetPassword(email) {
    const endpoint = this.endpoint('/v1/user/password/reset')
    return connectHttpBase.getHttpClient().put(endpoint, { email }) // ログイン不要
  }

  oAuthLogin(oAuthLoginRequest) {
    const endpoint = this.endpoint('/v1/oauth')
    return connectHttpBase.getHttpClient().post(endpoint, oAuthLoginRequest)
  }

  refreshAccessToken() {
    const userInfo = storage.getUserInfo()
    if (!userInfo) {
      return Promise.reject('UserInfo is empty in storage')
    }
    const refreshToken = storage.getRefreshToken()
    if (!refreshToken) {
      return Promise.reject('refresh token is not found.')
    }

    const endpoint = this.endpoint('/token')

    // ここのエンドポイントはFormでPOST
    let formData = new URLSearchParams()
    formData.append('grant_type', 'refresh_token')
    formData.append('refresh_token', refreshToken)
    formData.append('email', userInfo.email)
    return connectHttpBase.getHttpClient().post(endpoint, formData)
  }

  getMe() {
    const endpoint = this.endpoint('/v1/user')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  getUserGroupsInfo() {
    const endpoint = this.endpoint('/v1/user/groups')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  simpleSignUpAndSignIn(request) {
    const endpoint = this.endpoint('/v1/signup')
    return connectHttpBase.getHttpClient().post(endpoint, request)
  }

  updateUser(userData) {
    const endpoint = this.endpoint('/v1/user')
    const request = {
      nickname: userData.nickname,
      sendMeNews: userData.sendMeNews,
      language: userData.language,
      systemOfUnits: userData.systemOfUnits,
    }
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, request)
  }

  updateUserIcon(params) {
    const endpoint = this.endpoint('/v1/user/icon')
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, params)
  }

  impersonate(targetUserEmail) {
    let endpoint = this.endpoint('/v1/impersonate')
    const request = { targetUserEmail }
    return connectHttpBase.getAuthenticatedHttpClient().post(endpoint, request)
  }

  getRtkSettingInfo() {
    const endpoint = this.endpoint('/v1/caster/setting/rtk')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  listCurrentCasterBaseAndClient() {
    const endpoint = this.endpoint('/v1/caster/current')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  /**
   * 自分のマウントポイントの補正情報統計 (基準局の受信状況) を取得する。
   * @param {number|null} historyMinutes 1分集計履歴を何分ぶん含めるか (null なら現在値のみ)
   */
  getCasterStats(historyMinutes = null) {
    let endpoint = this.endpoint('/v1/caster/stats')
    if (historyMinutes) {
      endpoint += `?history=${historyMinutes}`
    }
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  /**
   * 自分のマウントポイントの移動局軌跡 (GGA記録) を取得する。
   */
  getCasterTrack() {
    const endpoint = this.endpoint('/v1/caster/track')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }
}

const connectAuthClient = new ConnectAuthClient()
export default connectAuthClient
